/** Google Ads conversion tag (AW-18108668059) — site-wide via index.html + App.js route tracker. */
export const GOOGLE_ADS_ID = 'AW-18108668059';

/** Primary campaign landings; always included when tracking all routes. */
export const GOOGLE_ADS_PRIORITY_ROUTES = ['/', '/recuperacion', '/flotas'];

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
  }
}

let scriptLoadPromise = null;

export function loadGoogleAdsTag() {
  ensureGtagStub();
  const alreadyInDom = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}"]`,
  );
  if (window.__googleAdsScriptLoaded || alreadyInDom) {
    window.__googleAdsScriptLoaded = true;
    return Promise.resolve();
  }
  if (!scriptLoadPromise) {
    scriptLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
      script.onload = () => {
        window.__googleAdsScriptLoaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return scriptLoadPromise;
}

/** Fire (or refresh) page view on SPA route changes (all app routes). */
export function trackGoogleAdsPage(pagePath) {
  return loadGoogleAdsTag()
    .then(() => {
      window.gtag('config', GOOGLE_ADS_ID, { page_path: pagePath });
    })
    .catch(() => {
      /* non-blocking: analytics must not break the app */
    });
}
